import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { initAmplitude } from './analytics/amplitude';

// Flag-gated Amplitude browser analytics. No-op unless environment.amplitude.enabled is true.
void initAmplitude();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));